export const truncateText = (value: string | number | null | undefined, maxLength: number) => {
    const text = value == null ? '' : String(value);
    const limit = Math.max(0, maxLength);

    if (text.length <= limit) {
        return text;
    }

    if (limit <= 3) {
        return '.'.repeat(limit);
    }

    return `${text.slice(0, limit - 3).trimEnd()}...`;
};
